import axios from "axios";
import { toast } from "sonner";

// Helper to get CSRF token from cookies
function getCookie(name: string): string | null {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(";").shift() || null;
  return null;
}

// Use environment variable or default to current origin for production
const getBaseURL = () => {
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }
  // In production, use relative URLs (same origin)
  // In development, use localhost
  if (import.meta.env.MODE === 'production') {
    return '';
  }
  return "http://localhost:8000";
};

export const customInstance = axios.create({
  baseURL: getBaseURL(),
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add CSRF token
customInstance.interceptors.request.use(
  (config) => {
    // Add CSRF token for unsafe methods
    if (["POST", "PUT", "PATCH", "DELETE"].includes(config.method?.toUpperCase() || "")) {
      const csrftoken = getCookie("csrftoken");
      if (csrftoken) {
        config.headers["X-CSRFToken"] = csrftoken;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle 401
customInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Don't redirect for /api/auth/me/ - let auth context handle it
      // This prevents redirect loops and allows graceful auth state handling
      const url = error.config?.url || "";
      const isAuthMeEndpoint = url.includes("/api/auth/me/");
      const isPublicCustomerSign = url.includes("/api/customer-sign/");
      if (!isAuthMeEndpoint && !isPublicCustomerSign) {
        // Redirect to login for other endpoints
        window.location.href = "/login";
      }
    }
    if (error.response?.status >= 500) {
      const url = error.config?.url || "";
      const isAuthMeEndpoint = url.includes("/api/auth/me/");
      // auth/me runs on every public page load; a brief upstream 502 during deploy
      // should not alarm anonymous visitors with a toast
      if (!isAuthMeEndpoint) {
        toast.error(error.response?.data?.error || "Server error occurred");
      }
    }
    return Promise.reject(error);
  }
);

export default customInstance;







